import { render, staticRenderFns } from "./WeeklyScheduleModal.vue?vue&type=template&id=bf32910c&scoped=true"
import script from "./WeeklyScheduleModal.vue?vue&type=script&lang=js"
export * from "./WeeklyScheduleModal.vue?vue&type=script&lang=js"
import style0 from "./WeeklyScheduleModal.vue?vue&type=style&index=0&id=bf32910c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf32910c",
  null
  
)

export default component.exports